export default {
  path: '/wecode/:type/list',
  auth: true,
  preload: false,
  key: 'robot',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
